import React, { FC, memo } from 'react';
import DefaultSelect from 'components/Form/Select';
import { Props } from './types';
import useConnect from './connect';

const BrandSelect: FC<Props> = ({
  value,
  setSelectedId,
  allowAllOption,
  ...props
}) => {
  const { options, isLoadingBrands, handleChangeSelect } = useConnect({
    allowAllOption,
    value,
    setSelectedId,
  });

  if (isLoadingBrands && value === undefined) {
    return <>loading...</>;
  }

  return (
    <DefaultSelect
      onChange={handleChangeSelect}
      value={value}
      options={options}
      disabled={isLoadingBrands}
      {...props}
    />
  );
};

export default memo(BrandSelect);
